import type { SVGProps } from 'react';
const SvgQuotesLight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={35} height={26} {...props}>
    <path
      fill="#DEE4DF"
      d="M8.514 25.52c4.346 0 7.528-2.86 7.528-7.106 0-4.47-3.003-7.061-7.215-7.061-2.195 0-4.077.804-5.377 2.19a7.3 7.3 0 0 1-.179-1.699c0-.67.09-1.34.269-2.1.538-3.219 3.45-6.57 6.9-8.09L9.635 0C3.047 3.04 0 8.581 0 14.66c0 2.86.717 5.766 2.016 7.643 1.3 2.011 3.496 3.218 6.498 3.218zm18.958 0c4.347 0 7.528-2.86 7.528-7.106 0-4.47-3.002-7.061-7.214-7.061-2.196 0-4.078.804-5.377 2.19a7.7 7.7 0 0 1-.18-1.744c0-.67.045-1.34.224-2.055.583-3.219 3.496-6.57 6.946-8.09L28.547 0c-6.542 3.04-9.589 8.581-9.589 14.66 0 2.86.717 5.766 1.972 7.643 1.344 2.011 3.54 3.218 6.542 3.218z"
    />
  </svg>
);
export default SvgQuotesLight;
